import { memo } from "react";

import { useSheetModal } from "./SheetModal";
import { SheetModalGrabber } from "./SheetModalGrabber";

import type { PointerEvent } from "react";

export interface SheetModalHeaderProps {}

export const SheetModalHeader = memo(function SheetModalHeader() {
  const { dragControls, disableGestures, disableGrabber } = useSheetModal();

  function handlePointerDown(event: PointerEvent) {
    if (!disableGestures) {
      dragControls?.start(event);
    }
  }

  return (
    <div
      onPointerDown={handlePointerDown}
      className="SheetModalHeader"
      style={{
        touchAction: !disableGestures ? "none" : undefined,
      }}
    >
      {!disableGrabber && <SheetModalGrabber />}
    </div>
  );
});
